function HomeQuoteConfiguration(){
	this.coverTypeClasses = {
		building_and_contents: {
			label : 'Building & contents',
			subClasses : {
				standard: {
					label: 'Building & contents',
					descriptor: 'building_and_contents',
					superType: 'building_and_contents'
				},
			}
		},

		building_only: {
			label : 'Building only',
			subClasses : {
				standard: {
					label: 'Building only',
					descriptor: 'building_only',
					superType: 'building_only'
				},
			}
		},
		contents_only: {
			label : 'Contents',
			subClasses : {
				standard: {
					label: 'Contents',
					descriptor: 'contents_only',
					superType: 'contents_only'
				},
			}
		},
	};

	this.allCoverTypes = {
		building_and_contents: this.coverTypeClasses.building_and_contents.subClasses.standard,
		building_only: this.coverTypeClasses.building_only.subClasses.standard,
		contents_only: this.coverTypeClasses.contents_only.subClasses.preferred,
	};

	this.allOfferings = {
		QPHStandardOffering: {
			label: 'Standard',
			descriptor: 'QPHStandardOffering',
			superType: ''
		},
		QPHPrestigeOffering: {
			label: 'Prestige',
			descriptor: 'QPHPrestigeOffering',
			superType: ''
		},
		QPHLandlordOffering: {
			label: 'Landlord',
			descriptor: 'QPHLandlordOffering',
			superType: ''
		},
		QPHStrataContentsOffering: {
			label: 'Strata Contents',
			descriptor: 'QPHStrataContentsOffering',
			superType: ''
		}
	};


		//get required covertypes
	this.getOfferingPermutations = function(quoteOptions, coverOptions, selectedCoverType, selectedOffering){
		quoteOptions.permutations.offerings = [selectedOffering];
		quoteOptions.permutations.coverTypes = [selectedCoverType];

		if ( ! selectedOffering ) {
			applicableOfferings = getOfferings( coverOptions.homeOccupancy, coverOptions.buildingType, coverOptions.needs, coverOptions.needRapidEstimate);
			//select permutations in homequote configuration based on the above logic
			var permutationsBasedOnSelection = [];
			angular.forEach(this.allOfferings, function(offering){
				if(applicableOfferings.indexOf(offering.descriptor)>-1){
					permutationsBasedOnSelection.push(offering);
				}
			});
			quoteOptions.permutations.offerings = permutationsBasedOnSelection;
		}

		return quoteOptions;
	}


	function getOfferings(homeOccupancy, buildingType, needs, needRapidEstimate){
		//logic from exsting portal
		var offerings = [];
		if (
			(homeOccupancy === 'own_live' ||
			homeOccupancy === 'rent_live' ||
			homeOccupancy === 'own_holidayhome') && !(buildingType === 'unit' || buildingType === 'flat')
		) {
			offerings.push('QPHStandardOffering');
			if (needRapidEstimate) {
				offerings.push('QPHPrestigeOffering');
			}

		} else if (
			(homeOccupancy === 'own_live' ||
			homeOccupancy === 'rent_live' ||
			homeOccupancy === 'own_holidayhome') &&
			(buildingType === 'unit' || buildingType === 'flat') &&
			needs.building
		) {
			offerings.push('QPHStandardOffering');
			if (needRapidEstimate) {
				offerings.push('QPHPrestigeOffering');
			}

		} else if (
			(homeOccupancy === 'own_live' ||
			homeOccupancy === 'rent_live' ||
			homeOccupancy === 'own_holidayhome') &&
			(buildingType === 'unit' || buildingType === 'flat') &&
			needs.contents
		) {
			offerings.push('QPHStrataContentsOffering');
			if (needRapidEstimate) {
				offerings.push('QPHPrestigeOffering');
			}

		} else if (
			(homeOccupancy === 'own_rent_tenants' ||
			homeOccupancy === 'own_rent_tenants_causalbasis' ||
			homeOccupancy === 'property_used_hostel_or_guest')
		) {
			offerings.push('QPHLandlordOffering');
		}
		return offerings;
	}

	this.allPaymentFrequencies = {
		annual: 'everyyear',
		monthly: 'monthly',
		fortnightly: 'everyotherweek',
	};

	this.defaultPaymentFrequency = this.allPaymentFrequencies.annual;

	this._reversePaymentFrequenciesLookup = {
		yearly: 'annual',
		monthly: 'monthly',
		fortnightly: 'fortnightly',
	};

	this.allQuoteTypes = {
		full: 'Full',
		quick: 'Quick',
	};

	this.defaultOffering = this.allOfferings.QPHStandardOffering ;

	this.quoteRuleOptions = {
		// Rapid estimate quote options
		'rapidEstimate': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.estimate' // Note : THESE ARE GUIDEWIRE RULESET AND DO NOT NECESSARILY CORRESPOND TO PAGE NAMES.
			},
			permutations: {
				quoteType: this.allQuoteTypes.quick,
				useSelectedOffering: false,
				paymentFrequencies: [this.allPaymentFrequencies.annual, this.allPaymentFrequencies.monthly]
			}
		},
		'home.property': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.property' // Note : THESE ARE GUIDEWIRE RULESET AND DO NOT NECESSARILY CORRESPOND TO PAGE NAMES.
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.building': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.building'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual, this.allPaymentFrequencies.monthly]
			}
		},
		'home.covers': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.covers'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.details': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.details'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: Object.values(this.allPaymentFrequencies)
			}
		},
		'home.quote': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.quote'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: Object.values(this.allPaymentFrequencies)
			}
		},
		'home.contact': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.additional'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: Object.values(this.allPaymentFrequencies)
			}
		},
		'home.payment': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.payment'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: Object.values(this.allPaymentFrequencies)
			}
		}
	};

	this.testQuoteDeclineOptions = {
		'home.estimate' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.estimate'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.property' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.property'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.building' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.building'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.covers' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.covers'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.details' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.details'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.quote' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.quote'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.contact' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.additional'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.payment' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.payment'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
	}

	/** cover type for home needs to be determine in step 1 and cannot be defaulted */
	this.defaultCoverType = null;
	this.defaultRequotePageName = 'home.quote';
}
